import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Shop.module.sass";
import Profile from "./Profile";
import Card from "../../components/Card";
import Dropdown from "../../components/Dropdown";

// screen
import DocumentsAndFiles from "./DocumentsAndFiles";
import ContractAndFiles from "./ContractAndFiles";
import NameAndDescription from "./NameAndDescription";

// data
import { getCurrentStudentInfo } from "../../services/account.service";
import { getStudentDocuments } from "../../services/documents.service";

const navigation = ["Informations","Documents", "Contrats"];

const Account = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasSubmittedDocuments, setHasSubmittedDocuments] = useState(false);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const data = await getCurrentStudentInfo();
        if (data && data.student) {
          setStudent(data.student);
          
          // Vérifier les documents soumis
          const documentsResult = await getStudentDocuments(data.student.id, {
            filter: `student_id = "${data.student.id}" && statut = "submitted"`
          });
          
          setHasSubmittedDocuments(documentsResult.items.length > 0);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données de l'étudiant:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudentData();
  }, []);

  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <Card className={styles.card}>
          <Profile student={student} />
          <div className={styles.control}>
            <div className={cn(styles.nav, styles.desktopNav)}>
              {navigation.map((x, index) => (
                <button
                  className={cn(styles.link, {
                    [styles.active]: index === activeIndex,
                  })}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  {x}
                </button>
              ))}
            </div>
            <div className={styles.mobileNav}>
              <div style={{ position: 'relative' }}>
                <Dropdown
                  className={styles.dropdown}
                  value={navigation[activeIndex]}
                  setValue={(value) => {
                    const index = navigation.findIndex(x => x === value);
                    if (index !== -1) setActiveIndex(index);
                  }}
                  options={navigation}
                />
              </div>
            </div>
          </div>
          </Card>
          <div className={styles.wrap}>
            {activeIndex === 0 && (
              <NameAndDescription student={student}/>
            )}
            {activeIndex === 1 && (
              <DocumentsAndFiles studentId={student?.id}/>
            )}
            {activeIndex === 2 && (
              <ContractAndFiles studentId={student?.id}/>
            )}
          </div>
      </div>
    </>
  );
};

export default Account;
